import { Helmet } from "react-helmet-async";
import Header from "@/components/Header";
import footer_img from "../assets/footer_img.jpg";

interface AppLayoutProps {
    children: React.ReactNode;
    title?: string;
    sidebarOpen?: boolean;
    onToggleSidebar?: () => void;
}

export default function AppLayout({ children, title }: AppLayoutProps) {
    return (
        <>
            <Helmet>
                <title>{title || "FairLegal"}</title>
            </Helmet>
            <div className="min-h-screen bg-white max-w-[95%] my-4 mx-auto">
                {/* Header */}
                <Header />

                {/* Main Content */}
                <main className="flex h-full mt-8">{children}</main>
                <div>
                    <img src={footer_img} alt="FairLegal" className="w-[50%] h-auto mx-auto object-contain pt-10" />
                </div>
            </div>
        </>
    );
}
